"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyHoursOfOperation = exports.HoursOfOperationTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const nullable_1 = require("../common/nullable");
const DailyHours = typebox_1.Type.Object({
    open: typebox_1.Type.Boolean(),
    start: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    end: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
});
exports.HoursOfOperationTransport = typebox_1.Type.Object({
    mon: DailyHours,
    tue: DailyHours,
    wed: DailyHours,
    thu: DailyHours,
    fri: DailyHours,
    sat: DailyHours,
    sun: DailyHours,
});
exports.EmptyHoursOfOperation = {
    mon: { open: false },
    tue: { open: false },
    wed: { open: false },
    thu: { open: false },
    fri: { open: false },
    sat: { open: false },
    sun: { open: false },
};
//# sourceMappingURL=hours-of-operation-transport.js.map